import loadable from '@loadable/component';

export const HorseandhoundSiteWrapper = loadable(
  () => import(/* webpackChunkName: "horseandhound-site" */ './HorseandhoundSiteWrapper'),
);
